import { createSelector } from 'reselect';
import get from 'lodash/get';

export const None = -1;

export const stateSelector = state => state;
export const propsSelector = (_, props) => props;
export const targetWorkflowIDSelector = createSelector(
  propsSelector,
  props =>
    get(props, 'workflowId', null) || get(window, 'ADV.data.user.ConsumerAccessWorkflow', None),
);
export const clientIDSelector = createSelector(
  propsSelector,
  props => get(props, 'clientId', null),
);
